<script setup>
import { pageTransition } from '~/helpers/animations/animations';

definePageMeta({
  pageTransition: pageTransition,
});

const pageQuery = gql`
  query GetPageData {
    page(id: 32) {
      seo_meta_title
      seo_meta_description
      seo_meta_keywords
      id
      breadcrumbs {
        name
        route_id
      }
      name
      perex
      content
      children {
        id
        name
        image
        perex
        route_id
        slug: seo_url_slug {
          cs
          en
        }
      }
    }
  }
`;

const { clients } = useApollo();
const { locale } = useI18n();

const { data, error } = await useAsyncData(`education-kids-${locale.value}`, () =>
  clients.default.query({
    query: pageQuery,
    fetchPolicy: 'network-only',
  })
);

const page = computed(() => data.value?.data?.page);
const content = computed(() => data.value?.data?.page.content);

const breadcrumbs = useBreadCrumbs(data.value?.data?.page.breadcrumbs || []);

const perex = computed(() => [
  {
    type: 'perex',
    data: {
      text: page.value?.perex,
    },
  },
]);

useHead({
  title: page.value ? (page.value?.seo_meta_title ? page.value?.seo_meta_title : page.value?.name) : null,
  description: page.value && page.value?.seo_meta_description ? page.value?.seo_meta_description : null,
  keywords: page.value && page.value?.seo_meta_keywords ? page.value?.seo_meta_keywords : null,
});
</script>

<template>
  <main class="main">
    <div v-if="page">
      <Breadcrumbs :items="breadcrumbs" />
      <h1 class="heading">{{ page.name }}</h1>
      <DynamicPageContent
        :content="[
          {
            type: 'paragraph',
            data: { text: page.perex },
          },
        ]"
        class="mt-3"
      />
      <DynamicPageContent :content="content" class="mt-5" />
      <div class="container-content">
        <Card
          v-for="(child, index) in page.children"
          :key="child.id"
          :link="localePath(useNoTemplating(child.route_id))"
          :heading="child.name"
          :image-src="child.image"
          mobile-image-ratio="2:1"
          class="mt-5"
          :class="{ 'mt-sm-4': index > 0 }"
          vcenter
        >
          <p class="text text--2" v-html="child.perex" />
        </Card>
      </div>
    </div>
  </main>
</template>
